import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
const qmsUrl = process.env.REACT_APP_EAGLE_QMS_BACKEND_URL;

function Login() {
  const [email, setEmail] = useState("");
  const [specialKey, setSpecialKey] = useState(Array(6).fill(""));
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSpecialKeyChange = (e, index) => {
    const { value } = e.target;

    // Update current box value
    if (/^[a-zA-Z0-9]?$/.test(value)) {
      const newKey = [...specialKey];
      newKey[index] = value.toUpperCase(); // Ensure uppercase letters
      setSpecialKey(newKey);

      // Move focus to next input if value exists and it's not the last box
      if (value && index < 5) {
        document.getElementById(`specialKey-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !specialKey[index] && index > 0) {
      // Move to previous box on backspace if current box is empty
      document.getElementById(`specialKey-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("Text").slice(0, 6); // Only take first 6 characters
    if (/^[a-zA-Z0-9]*$/.test(pasteData)) {
      const newKey = Array(6)
        .fill("")
        .map((_, i) => pasteData[i] || ""); // Fill boxes with pasted data
      setSpecialKey(newKey);

      // Focus the last filled box
      const lastIndex = pasteData.length - 1;
      document.getElementById(`specialKey-${Math.min(lastIndex, 5)}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await axios.post(`${qmsUrl}/api/qms-login`, {
        email,
        specialKey: specialKey.join(""),
      });

      // Save details in localStorage------
      const { employee, user } = response.data;
      // new added code
      let authTokens = JSON.parse(localStorage.getItem("All_authTokens")) || []; //make a new array for tokens
      let employeeDetails1 =
        JSON.parse(localStorage.getItem("All_employeeDetails1")) || []; //make a new array for empioyee
      let userDetails1 =
        JSON.parse(localStorage.getItem("All_userDetails1")) || []; //make a new array for users
      const newToken = response.data.employee.id; // latest token
      const Newemployee = response.data.employee;
      const Newuser = response.data.user;
      if (!authTokens.includes(newToken)) {
        authTokens.push(newToken); // Add to token array
        localStorage.setItem("All_authTokens", JSON.stringify(authTokens));
        employeeDetails1.push(Newemployee);
        localStorage.setItem(
          "All_employeeDetails1",
          JSON.stringify(employeeDetails1)
        ); // Save employee details
        userDetails1.push(Newuser);
        localStorage.setItem("All_userDetails1", JSON.stringify(userDetails1)); // Save user details
      } else {
        // console.log("already have token", newToken);
      }
      localStorage.setItem("authToken", newToken);
      localStorage.setItem("employeeDetails", JSON.stringify(Newemployee));
      localStorage.setItem("userDetails", JSON.stringify(Newuser));
      sessionStorage.setItem("currentToken", newToken);
      sessionStorage.setItem(
        "currentemployeeDetails",
        JSON.stringify(Newemployee)
      );
      sessionStorage.setItem("currentuserDetails", JSON.stringify(Newuser));
      navigate("/panel");
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "An error occurred during login.";
      setErrorMessage(errorMsg);
    }
  };

  return (
    <div className="login-container">
      <div className="left-section">
        <h1>Welcome to QMS Chatbot</h1>
        <p>Streamlining your operations with simplicity and intelligence.</p>
      </div>
      <div className="right-section">
        <form className="login-form" onSubmit={handleSubmit}>
          <h2>Login</h2>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="input-email-qms"
              autoComplete="off"
            />
          </div>
          <div className="form-group">
            <label>Special Key</label>
            <div className="special-key-inputs" onPaste={handlePaste}>
              {specialKey.map((digit, index) => (
                <input
                  key={index}
                  id={`specialKey-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleSpecialKeyChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  required
                  autoComplete="off"
                />
              ))}
            </div>
          </div>
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
